import Button from '@zenbusiness/zui/Button';
import Card from '@zenbusiness/zui/Card';
import DialogContent from '@zenbusiness/zui/DialogContent';
import DialogHeader from '@zenbusiness/zui/DialogHeader';
import Divider from '@zenbusiness/zui/Divider';
import IconButton from '@zenbusiness/zui/IconButton';
import List from '@zenbusiness/zui/List';
import ListItem from '@zenbusiness/zui/ListItem';
import PageHeader from '@zenbusiness/zui/PageHeader';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Stack from '@zenbusiness/zui/Stack';
import { superstyled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

export const ButtonLink = superstyled({
  tag: Button,
  name: 'AccountSettings',
  slot: 'ButtonLink',
  styles: () => ({
    padding: 0,

    '&:hover, &:focus': {
      backgroundColor: 'transparent',
    },

    '& span': {
      margin: 0,
    },
  }),
});

export const InfoValue = superstyled({
  tag: Text,
  name: 'AccountSettings',
  slot: 'InfoValue',
  styles: () => ({
    wordBreak: 'break-word',
    whiteSpace: 'normal',
  }),
});

export const ListInfo = superstyled({
  tag: List,
  name: 'AccountSettings',
  slot: 'ListInfo',
  styles: ({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: theme.spacing(3),

    [theme.breakpoints.up('sm')]: {
      gridTemplateColumns: '1fr 1fr',
    },
  }),
});

export const InfoItem = superstyled({
  tag: ListItem,
  name: 'AccountSettings',
  slot: 'InfoItem',
  styles: () => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: 0,
    gap: '0.25rem',
  }),
});

export const OptPartner = superstyled({
  tag: Stack,
  name: 'AccountSettings',
  slot: 'OptPartner',
  styles: ({ theme }) => ({
    gap: theme.spacing(3),
    alignItems: 'flex-start',
    '& button': {
      width: '100%',
    },

    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      justifyContent: 'space-between',

      '& button': {
        width: 'auto',
      },

      '& p': {
        width: '75%',
      },
    },
  }),
});

export const CloseButton = superstyled({
  tag: IconButton,
  name: 'AccountSettings',
  slot: 'CloseButton',
  styles: () => ({
    margin: '0 0 0 auto',
    borderRadius: '100%',
  }),
});

export const HeaderModal = superstyled({
  tag: DialogHeader,
  name: 'AccountSettings',
  slot: 'HeaderModal',
  styles: () => ({
    alignItems: 'center',
    textAlign: 'center',
    padding: '0 !important',
  }),
});

export const Header = superstyled({
  tag: PageHeader,
  name: 'AccountSettings',
  slot: 'Header',
  styles: ({ theme }) => ({
    marginBlockEnd: theme.spacing(3),
  }),
});

export const AccountCard = superstyled({
  tag: Card,
  name: 'AccountSettings',
  slot: 'AccountCard',
  styles: ({ theme }) => ({
    padding: theme.spacing(3),

    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(4),
    },
  }),
});

export const SectionDivider = superstyled({
  tag: Divider,
  name: 'AccountSettings',
  slot: 'SectionDivider',
  styles: () => ({
    margin: '2rem 0',
  }),
});

export const ModalContent = superstyled({
  tag: DialogContent,
  name: 'AccountSettings',
  slot: 'ModalContent',
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
  }),
});

export const EmailIllustration = superstyled({
  tag: SharedAsset,
  name: 'AccountSettings',
  slot: 'EmailIllustration',
  styles: ({ theme }) => ({
    width: '150px',

    [theme.breakpoints.up('sm')]: {
      width: '235px',
    },
  }),
});

export const ContactCard = superstyled({
  tag: Card,
  name: 'AccountSettings',
  slot: 'ContactCard',
  styles: ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(3),

    [theme.breakpoints.up('sm')]: {
      justifyContent: 'center',
      flexDirection: 'column',
    },
  }),
});
